import script from "./PayoutReviewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PayoutReviewModal.vue?vue&type=script&setup=true&lang=js"

import "./PayoutReviewModal.vue?vue&type=style&index=0&id=4de234c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4de234c4"]])

export default __exports__